import { render } from "./shopManage.vue?vue&type=template&id=a34506dc&scoped=true"
import script from "./shopManage.vue?vue&type=script&lang=js"
export * from "./shopManage.vue?vue&type=script&lang=js"

import "./shopManage.vue?vue&type=style&index=0&id=a34506dc&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a34506dc"]])

export default __exports__